import React from 'react';
import { Input, Icon } from 'antd';

export default class INNInput extends React.Component {

    onChange = (e) => {
        const { value } = e.target;
        this.props.onChange(value);
    }

    render() {
        let rp = { ...this.props };
        delete rp.allowClear;

        return (
            <Input {...rp}
                onChange={this.onChange}
                maxLength={10}
            />
        )
    }
}
